import { Config } from '../config';
import { isEUprod } from '../utils';
import { useFleet } from './useFleet';

export const useRejectionReasonTagID = (reviewType: 'internal' | 'external') => {
  const fleet = useFleet();
  // Use special rejection reason tag for AC transit in customer-facing review
  let rejectionReasonTagId = fleet.config.portal_config?.rejection_reason_tag_id ?? Config.DEFAULT_REJECTION_REASON_TAG_ID;
  if (reviewType === 'internal') {
    // fixme: this is a temporary fix for the EU pilot
    if (Config.INSTANCE === 'eupilot' || isEUprod()) {
      rejectionReasonTagId = Config.DEFAULT_REJECTION_REASON_TAG_ID_EU;
    } else {
      rejectionReasonTagId = Config.DEFAULT_REJECTION_REASON_TAG_ID;
    }
  }

  return rejectionReasonTagId;
};
